import React, { Component } from 'react';
import moment from 'moment';
import postService from '../../../../services/httpService';
import networkList from '../../../../constants/networkList';
import { Modal } from 'antd';
import Storage from './../../../../services/local-store';
import $ from 'jquery';
import html2PDF from 'jspdf-html2canvas';
import formDataPostService from '../../../../services/httpformData';
import userTrackService from './../../../../services/usertrack-service';

const {homepage} = networkList;
class Fc_Patient_copy extends Component {

    constructor(props) {
        super(props);
        this.state = {
            'printData': {},
            'estimate_type':0
        }
        this.checkBreak = this.checkBreak.bind(this);
    }

    componentDidMount() {
        window.scrollTo({
            top: 50,
            left: 0,
            behavior: 'smooth'
        });
        let print_response = null;
        let user_data = null;
        const params = new URLSearchParams(this.props.location.search);
        const nav_from = params.get('nav_from');       
            if(nav_from && nav_from === 'patients-history' || nav_from === 'on-bed-patients'){
                this.patient_details()
            }else if (localStorage.getItem('print_response') !== null) {
            print_response = JSON.parse(localStorage.getItem('print_response'));
            user_data = JSON.parse(localStorage.getItem('user_data'));
            this.setState((state) => ({ 'printData': print_response[0], 'user_data': user_data }))
            var that= this;
            setTimeout(function () {
                that.downloadPDF();
            }, 10000);
           
        }
    }
patient_details= () =>{
    const params = new URLSearchParams(this.props.location.search);
    const token_data = params.get('token_data');
    const payment = params.get('payment_type');
    let {getCounsellingPrintDetails} = networkList;
    postService(getCounsellingPrintDetails, 'POST', { data: { "counselling_id": parseInt(token_data),"payment_type": payment }   }).then(res => {
        console.log('getCounsellingPrintDetails:',res);               
        this.setState((state) => ({ loadding: false }));
        if (res.status) {
            // let user_data = JSON.parse(localStorage.getItem('user_data'));
            this.setState((state) => ({ 'printData': res['data'][0] }))           
        } else {
            Modal.error({
                title: 'Error Message',
                content: 'Some Thing went wrong,Please try again. later',

            })
        }
        }).catch((error) => {
            this.setState((state) => ({ loadding: false }));
            console.log(error);
            Modal.error({
                title: 'Error Message',
                content: 'Some Thing went wrong,Please try again. later',

            })
        });
}
back(){
    const params = new URLSearchParams(this.props.location.search);
    const nav_from = params.get('nav_from');
    const ip_id = params.get('ip');                
    const umr = params.get('umr');
    const unit = params.get('unit_id');
    if(nav_from && nav_from === 'patients-history'){

        this.props
        .history
        .push(`/patients/patients-history-details?umr=${umr}&unit_id=${unit}`)
    }
    if(nav_from && nav_from === 'on-bed-patients'){

        this.props
        .history
        .push(`/patients/on-bed-patient-details?patient_ip=${ip_id}&umr_no=${umr}&tab=2`)
    }
    
    
}
    cancel() {
        const params = new URLSearchParams(this.props.location.search);
        const nav_from = params.get('nav_from');
        const ip_id = params.get('nav_ip');                
        const umr_no = params.get('umr');
        const unit_id = params.get('unit_id');

        if(unit_id){
            // navigation to patients-history
            this.props.history.push(`/patients`);
        } else if (nav_from) {
            if (nav_from === 'view-finanical-counselling' || nav_from === 'view-insurance-counselling') {
                this.props
                    .history
                    .push(`${homepage}/counselling/counselling-list`);
            } else {
                this.renderNextToken();
            }
            // this.props
            //     .history
            //     .push(`/${nav_from}?nav_ip=${ip_id}`);
        } else {
            this.renderNextToken();
        }

        localStorage.removeItem("print_response");
        // this
        //     .props
        //     .history
        //     .push(`/counselling/counsellor-view`);
    }


    renderNextToken() {
        const params = new URLSearchParams(this.props.location.search);
        let token_data = params.get('token_data');
        let { createFinancialCouncelling, nextPatientforQueue } = networkList;
        let obj = { 'id': token_data ? token_data : null }
        console.log(obj);
        const Userlogobj ={
            "data": {
                "user": JSON.parse(localStorage.getItem('user')),
                "action": "Next Patient for Queue - Request",
                "date": new Date(),
                "meta": obj
            }
        }
        userTrackService(Userlogobj);
        postService(nextPatientforQueue, 'POST', { 'data': obj }).then(res => {
            const Userlogobjres ={
                "data": {
                    "user": JSON.parse(localStorage.getItem('user')),
                    "action": "Next Patient for Queue - Response",
                    "date": new Date(),
                    "meta": res
                }
            }
            userTrackService(Userlogobjres);
            if (res['status']) {

                // this.nextRenderBody();
                this.checkBreak();
                localStorage.removeItem('finance_data');
                localStorage.removeItem('current_token');
                // this
                //     .props
                //     .history
                //     .push(`/counselling/counselling-print`);
            } else {
                this.setState((state) => ({ loadding: false }));
                Modal.error({
                    title: 'Error Message',
                    content: 'Token is not Updated, Please try again.',
                })
            }
        })
    }

    nextRenderBody() {
        let { nextAssignTokenToCounsellor } = networkList;
        const Userlogobj ={
            "data": {
                "user": JSON.parse(localStorage.getItem('user')),
                "action": "Next Assign Token To Counsellor - Request",
                "date": new Date(),
                "meta": null
            }
        }
        userTrackService(Userlogobj);
        
        postService(nextAssignTokenToCounsellor, 'GET', 'null').then(res => {
            const Userlogobjres ={
                "data": {
                    "user": JSON.parse(localStorage.getItem('user')),
                    "action": "Next Assign Token To Counsellor - Response",
                    "date": new Date(),
                    "meta": res
                }
            }
            userTrackService(Userlogobjres);
            if (res.status) {
                Storage.store('current_token', res['data']);
                this
                    .props
                    .history
                    .push(`/counselling/counsellor-view`);
            } else {
                if (res['break_status'] && res['break_status']) {
                    this.props
                    .history
                    .push(`/counselling/start`);
                }else{
                    this
                        .props
                        .history
                        .push(`/counselling/counsellor-view`);
                }
            }
        });
    }


    checkBreak() {
        const Userlogobj ={
            "data": {
                "user": JSON.parse(localStorage.getItem('user')),
                "action": "get User Break Status - Request",
                "date": new Date(),
                "meta": null
            }
        }
        userTrackService(Userlogobj);
        postService('getUserBreakStatus', 'GET', 'null').then(res => {
            const Userlogobjres ={
                "data": {
                    "user": JSON.parse(localStorage.getItem('user')),
                    "action": "get User Break Status - Response",
                    "date": new Date(),
                    "meta": res
                }
            }
            userTrackService(Userlogobjres);
            if (res.status) {
                if (res['data'] && res['data']['break_status'] && res['data']['break_status'] === 1) {



                    this.props
                        .history
                        .push(`${homepage}/counselling/start`);
                } else {
                    this.setState({ 'break_status': 0 })
                    this.nextRenderBody();


                }
                // this.setState({ 'break_status': res['data']['break_status'] })
                // console.log(res);
            } else {
                this.setState({ 'break_status': 0 })
            }
        });
    }


    onChange(checked) {
        console.log(`switch to ${checked}`);
    }
    print = () => {
        document.getElementById("myH1").style.margin = "-130px 0px 0px 0px";
        window.print();
        document.getElementById("myH1").style.margin = "0px";
    }
    downloadPDF = () => {   

    const params = new URLSearchParams(this.props.location.search);
    let token_data = params.get('token_data');
    const id = `pdf-div`;
    const input = document.getElementById(id);
    if(input !==null && input !=='' && input !==undefined && token_data !==null && token_data!=='' && token_data !== undefined){
        html2PDF(input, {
    jsPDF: {
      format: 'a4',
    },
    html2canvas: {
    scrollX: 0,
    scrollY: -window.scrollY,
    },
    imageType: 'image/jpeg',
    output: './pdf/generate.pdf',
    success: function(pdf) {
        // console.log("pdf output");
        // console.log(pdf);
        var blob = pdf.output('blob');
        var form_data = new FormData();
        form_data.append('upfile', blob);
        form_data.append("counselling_id", token_data);

        formDataPostService('fileUploadForPDF', 'POST', form_data).then(res => {
            console.log('response:', res);
        })
        //pdf.save(this.output);
  }
  });
    }
    
};
    render() {
        let { printData, user_data,estimate_type } = this.state;
        const params = new URLSearchParams(this.props.location.search);
        let referrer = params.get('nav_from');
        return (
            <div className="fc-patient-copy" id="pdf-div">
                <div className="p-4 bg-white" id="myH1">
                    <div className="clearfix pt-5">
                        <img src={homepage+"/assets/images/logo-black.png"} alt="Kims" className="float-left"></img>
                        <p className="float-right align-middle pb-0 my-2 ">KIMS-K/BILL/F/B/03</p>
                    </div>

                    <div>
                        <h1 className="text-p-bold text-center text-uppercase py-4">Financial counselling</h1>
                    </div>
                    <div className="row m-0 pb-3 border">
                        <div className="col-4 ">
                            <div className="d-inline-flex">
                                <span className="w-label">Date of Counselling</span>
                                <span className="w-100">: {moment(printData['counselling_date']).format('YYYY-MM-DD')}</span>
                            </div>
                        </div>
                        <div className="col-4 ">
                            <div className="d-inline-flex">
                                <span className="w-label">Counselling type</span>
                                <span className="w-100">: {printData['counselling_type'] || printData['counselling_type_value']}</span>
                            </div>
                        </div>
                        <div className="col-4 ">
                            <div className="d-inline-flex">
                                <span className="w-label">UMR number</span>
                                <span className="w-100">: {printData['umr']}</span>
                            </div>
                        </div>
                        <div className="col-4 ">
                            <div className="d-inline-flex">
                                <span className="w-label">Patient Name</span>
                                <span className="w-100">: {printData['patient_name']}</span>
                            </div>
                        </div>
                        <div className="col-4 ">
                            <div className="d-inline-flex">
                                <span className="w-label">Patient Phone</span>
                                <span className="w-100">: {printData['patient_mobile']}</span>
                            </div>
                        </div>
                        <div className="col-4 ">
                            <div className="d-inline-flex">
                                <span className="w-label">Patient Age</span>
                                <span className="w-100">: {printData['patient_age']}</span>
                            </div>
                        </div>
                        <div className="col-4 ">
                            <div className="d-inline-flex">
                                <span className="w-label">Doctor Name</span>
                                <span className="w-100">: {printData['doctor_name']}</span>
                            </div>
                        </div>
                        <div className="col-4 ">
                            <div className="d-inline-flex">
                                <span className="w-label">Specialty</span>
                                <span className="w-100">: {printData['doctor_speciality']}</span>
                            </div>
                        </div>
                        <div className="col-4 ">
                            <div className="d-inline-flex">
                                <span className="w-label">Care Management</span>
                                <span className="w-100">: {printData['care_management_value'] || printData['care_management']}</span>
                            </div>
                        </div>
                        <div className="col-4 ">
                            <div className="d-inline-flex">
                                <span className="w-label">Mode of Payment</span>
                                <span className="w-100">: {printData['payment_type'] || printData['payment_type_value']}</span>
                            </div>
                        </div>

                        <div className="col-4 ">
                            <div className="d-inline-flex">
                                <span className="w-label">Length of Stay </span>
                                <span className="w-100">: {printData['lenght_of_stay']} (Approx days)</span>
                            </div>
                        </div>

                        <div className="col-4 ">
                            <div className="d-inline-flex">
                                <span className="w-label">Room Opted</span>
                                <span className="w-100">: {printData['room_opted_name']}</span>
                            </div>
                        </div>
                        <div className="col-4 ">
                            <div className="d-inline-flex">
                                <span className="w-label">Room Eligibility Ward</span>
                                <span className="w-100">: {printData['room_eligible_ward_name']}</span>
                            </div>
                        </div>
                        <div className="col-4 ">
                            <div className="d-inline-flex">
                                <span className="w-label">Room Upgrade</span>
                                <span className="w-100">: {printData['room_upgrade_name'] || printData['upgrade_room_name']}</span>
                            </div>
                        </div>
                        <div className="col-4 ">
                            <div className="d-inline-flex">
                                <span className="w-label">Upgrade Reason</span>
                                <span className="w-100">: {printData['room_upgrade_reason_value'] || printData['room_upgrade_reason']}</span>
                            </div>
                        </div>

                        <div className="col-8">
                            <div className="d-inline-flex">
                                <span className="w-label">Surgery/Procedure </span>
                                <span className="w-100">: {printData['surgery_procedure_name']}</span>
                            </div>
                        </div>
                        <div className="col-4 ">
                            <div className="d-inline-flex">
                                <span className="w-label">Date of Surgery</span>
                                <span className="w-100">: {printData['date_of_surgery']}</span>
                            </div>
                        </div>

                        <div className="col-4 ">
                            <div className="d-inline-flex">
                                <span className="w-label">Estimated Date of Admission</span>
                                <span className="w-100">: {printData['estimated_date_of_admission']}</span>
                            </div>
                        </div>


                    </div>

                    {(printData['payment_type_value'] && (printData['payment_type_value'] === 'Corporate' || printData['payment_type_value'] === 'ASRI')) && <React.Fragment>
                        <div className="clearfix py-4">
                            <div className="col-12">
                                <div className="d-inline-flex">
                                    <h5 className="w-label mb-1">Comments</h5>

                                </div>
                            </div>
                            <div className="col-12">
                                <div className="d-inline-flex pt-0">

                                    <p className="w-100">{printData['corporate_comments']}</p>
                                </div>
                            </div>
                        </div>
                    </React.Fragment>}
                    {(printData['payment_type_value'] && (printData['payment_type_value'] === 'Insurance' || printData['payment_type_value'] === 'CASH')) && <React.Fragment>


                        <div className="clearfix py-4">
                            <span className="float-left">
                                <h4 className="mb-0">Total Estimated Amount:</h4>
                            </span>
                            <span className="float-right">
                                <h4 className="mb-0">Rs. {printData['total_estimate_amount']}</h4>
                            </span>
                        </div>
                        <div >
                            <table className="table table-hover table-bordered">
                                <thead>
                                    <tr>
                                        <td className="text-capitalize" style={{ 'width': '5%' }}>s.no</td>
                                        <td className="text-capitalize">Service Group</td>
                                        <td className="text-capitalize" style={{ 'width': '20%' }}>Approx Amount</td>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>1</td>
                                        <td className="text-capitalize">Room Charges</td>
                                        <td className="text-uppercase">{printData['estimate_type']===1 ? '0.00': printData['room_charges']}</td>
                                    </tr>
                                    <tr>
                                        <td>2</td>
                                        <td className="text-capitalize">Pharmacy</td>
                                        <td className="text-uppercase">{printData['pharmacy_charges']}</td>
                                    </tr>
                                    <tr>
                                        <td>3</td>
                                        <td className="text-capitalize">Professional Fees & DMO</td>
                                        <td className="text-uppercase">{printData['professional_charges']}</td>
                                    </tr>
                                    <tr>
                                        <td>4</td>
                                        <td className="text-capitalize">Cross Consultation</td>
                                        <td className="text-uppercase">{printData['cross_consultation_charges']}</td>
                                    </tr>
                                    <tr>
                                        <td>5</td>
                                        <td className="text-capitalize">Investigations</td>
                                        <td className="text-uppercase">{printData['investigations_charges']}</td>
                                    </tr>
                                    <tr>
                                        <td>6</td>
                                        <td className="text-capitalize">Procedures</td>
                                        <td className="text-uppercase">{printData['procedures_charges']}</td>
                                    </tr>
                                    <tr>
                                        <td>7</td>
                                        <td className="text-capitalize">OT Charges</td>
                                        <td className="text-uppercase">{printData['ot_charges']}</td>
                                    </tr>
                                    <tr>
                                        <td>8</td>
                                        <td className="text-capitalize">General Equipment</td>
                                        <td className="text-uppercase">{printData['general_equipment_charges']}</td>
                                    </tr>
                                    <tr>
                                        <td>9</td>
                                        <td className="text-capitalize">OT Equipment / Instruments</td>
                                        <td className="text-uppercase">{printData['ot_equipment_charges']}</td>
                                    </tr>
                                    <tr>
                                        <td>10</td>
                                        <td className="text-capitalize">F & B and Dietician</td>
                                        <td className="text-uppercase">{printData['f_b_charges']}</td>
                                    </tr>
                                    <tr>
                                        <td>11</td>
                                        <td className="text-capitalize">Physiotherapy</td>
                                        <td className="text-uppercase">{printData['physiotherapy_charges']}</td>
                                    </tr>
                                    <tr>
                                        <td>12</td>
                                        <td className="text-capitalize">Medical Records and MLC</td>
                                        <td className="text-uppercase">{printData['mlc_charges']}</td>
                                    </tr>
                                    <tr>
                                        <td>13</td>
                                        <td className="text-capitalize">Blood Bank</td>
                                        <td className="text-uppercase">{printData['blood_blank_charges']}</td>
                                    </tr>
                                    <tr>
                                        <td>14</td>
                                        <td className="text-capitalize">Hospital Services</td>
                                        <td className="text-uppercase">{printData['hospital_charges']}</td>
                                    </tr>
                                    <tr>
                                        <td>15</td>
                                        <td className="text-capitalize">ICU Charges</td>
                                        <td className="text-uppercase">{printData['ambulance_charges']}</td>
                                    </tr>

                                </tbody>
                            </table>

                        </div>
                    </React.Fragment>}

                    <div className="insurance p-2">
                        {(printData['payment_type_value'] && printData['payment_type_value'] === 'Insurance') && <React.Fragment>
                            <h5 className="data-label w-100">Insurance:</h5>
                            <ul className="pl-3">
                                <li>Insurance Processing Charges (one time charge) will be billed in addition to the above charges for every patient admission.</li>
                                <li>In case a higher category room (beyond eligibility) is opted for, pro rata charges will be levied to you for all services availed.</li>
                                <li>List of Non-Medical Expenses & Insurance Checklist have been provided to you.</li>
                            </ul></React.Fragment>}
                        {(printData['payment_type_value'] && (printData['payment_type_value'] !== 'Corporate' && printData['payment_type_value'] !== 'ASRI')) && <React.Fragment>
                            <p className="one text-justify">Please note that all the above costs are quoted for the stipulated / tentative length of stay. Increase in length of stay or increase in OT time due to clinical complications/comorbidities will elicit additional charges, depending on the complexity of condition / extension of treatment / period.</p>
                            <ul className="pl-3">
                                <li>For cash paying patients, an advance of 80% of the total estimated amount shall be paid at the time of admission by Cash/Card.</li>
                                <li>All cash paying patients shall maintain a positive cash balance at any time during their stay for medical treatment in the hospital.</li>
                                <li>Excess Amount paid (up to Rs 10,000) will be refunded to you in cash immediately at the time of final bill clearance. Refunds of amounts more than Rs. 10,000 will be transferred by NEFT within 7 business days.</li>
                                <li>As per IT Section 269 ST, amount up to Rs 1,99,999 only will be accepted in Cash. Payment above Rs 2,00,000 can be paid through NEFT/DD/Card.</li>
                            </ul>
                        </React.Fragment>}
                        <h5 className="data-label w-100">Declaration:</h5>
                        <p className="one text-justify">I hereby accept that all the above tariff and breakup was explained to me/us in a language I/We understand in detail. I understand that the
                        amount quoted is only an estimate and the actual charges incurred at the time of the final bill may vary. I take full responsibility of clearing
                        all dues payable to the hospital by arranging payment either by myself or through immediate family of the patient, at the time of discharge / leaving the hospital.</p>
                        <div className="clearfix pt-4">
                            <span className="float-left">
                                Signature: ____________________
                            </span>
                            <span className="float-right">
                                Signature: ____________________
                            </span>
                        </div>
                        <div className="clearfix pt-4 pb-4">
                            <span className="float-left">
                                Patient/Attendant Name: ____________________
                            </span>
                            <span className="float-right">
                                Financial Counsellor: {printData['counsellor_name']} ({user_data ? user_data['kims_userid'] ? user_data['kims_userid'] : '--' : '--'})
                            </span>
                        </div>
                        {
                            (referrer != 'patients-history' &&  referrer != 'on-bed-patients') ? <div className="row justify-content-center pt-4">
                            <button className="btn btn-success d-print-none text-capitalize" onClick={this.print}>Print</button>
                            <button className="btn d-print-none btn-next text-capitalize ml-3" onClick={this.cancel.bind(this)}>cancel</button>
                        </div> : <div className="row justify-content-center pt-4"><button className="btn d-print-none btn-next text-capitalize ml-3" onClick={this.back.bind(this)}>Back</button></div>
                        }
                        
                    </div>
                </div>
            </div>
        )
    }
}

export default Fc_Patient_copy;